import { render, staticRenderFns } from "./SlideType.vue?vue&type=template&id=4fdffed2&scoped=true&"
import script from "./SlideType.vue?vue&type=script&lang=js&"
export * from "./SlideType.vue?vue&type=script&lang=js&"
import style0 from "../../css/slide.css?vue&type=style&index=0&id=4fdffed2&scoped=true&lang=css&"
import style1 from "./SlideType.vue?vue&type=style&index=1&id=4fdffed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdffed2",
  null
  
)

export default component.exports